module.exports = __webpack_public_path__ + "static/media/team_ceo.0d847fa9.png";